import { toDisplayString as _toDisplayString, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-f1ebb59c")

_pushScopeId("data-v-f1ebb59c")
const _hoisted_1 = { class: "layout-profile" }
const _hoisted_2 = { class: "username" }
const _hoisted_3 = /*#__PURE__*/_createVNode("i", { class: "pi pi-fw pi-cog" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("i", { class: "pi pi-fw pi-power-off" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("span", null, "ログアウト", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("button", {
      class: "p-link layout-profile-link",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.fncUserNameOnClick && _ctx.fncUserNameOnClick(...args)))
    }, [
      _createVNode("span", _hoisted_2, _toDisplayString(_ctx.fncGetUserName()), 1),
      _hoisted_3
    ]),
    _createVNode(_Transition, { name: "layout-submenu-wrapper" }, {
      default: _withId(() => [
        _withDirectives(_createVNode("ul", null, [
          _createVNode("li", null, [
            _createVNode("button", {
              class: "p-link",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.fncLogoutOnClick && _ctx.fncLogoutOnClick(...args)))
            }, [
              _hoisted_4,
              _hoisted_5
            ])
          ])
        ], 512), [
          [_vShow, _ctx.expanded]
        ])
      ]),
      _: 1
    })
  ]))
})